<template>
    <div class="whiteList bg_white" v-show="show">
        <div class="header">
            <button type="back" class="fr" @click="backEvent">返回</button>
        </div>
        <lists ref="lists" :data="lists" :listsStyle="listsStyle" :httpRequestData="httpRequestData" @deleteEvent="deleteEvent"></lists>
    </div>
</template>

<script>
    import Lists from '@/components/Lists'
    
    export default {
        name: "whiteList",
        components: {
            Lists
        },
        data() {
            return {
                show: false,
                point_id: null,
                lists: {
                    title: [{text: '基本信息'}, {text: 'openid'}, {text: '性别'}, {text: '省市'}, {text: '状态'}, {text: '操作'}]
                },
                listsStyle: [
                    {width: '25%', textAlign: 'left'},
                    {width: '25%', textAlign: 'left'},
                    {width: '15%', textAlign: 'center'},
                    {width: '15%', textAlign: 'left'},
                    {width: '10%', textAlign: 'left'},
                    {width: '10%', textAlign: 'left'},
                ],
                httpRequestData: {
                    url: '/manage/whitelist',
                    func: this.httpRequestHandle,
                    error: '获取白名单信息出错',
                    auto: false
                },
            }
        },
        computed: {
        },
        methods: {
            init(point_id) {
                this.show = true;
                this.point_id = point_id;
                this.$refs.lists.updateData({point_id: this.point_id});
            },
            closeEvent() {
                this.show = false;
            },
            httpRequestHandle(data) {
                let operation = {
                    arr: [{text: '删除',style: {color: '#FF2118'},event: 'deleteEvent'}]
                };
                return data.map(item =>{
                    let sex = item.sex === 1 ? '男' : '女';
                    let address = item.province + '·' + item.city + '';
                    return [
                        {text: item.name, img: {img_src: item.header, style: {width: '34px',height: '34px',marginRight: '6px',verticalAlign: 'middle'}}},
                        {text: item.openid},
                        {text: sex},
                        {text: address},
                        {text: this.$config.userStatus.get(item.status)},
                        operation
                    ]
                });
            },
            deleteEvent(data) {
                this.$delete({
                    title: '删除用户',
                    tooltipContent: '请输入当前用户名称以删除当前项目,数据将不可恢复，谨慎操作',
                    value: data.name,
                    confirm: () => {
                        this.$api.delete('/manage/whitelist/' + data.id, {
                            point_id: this.point_id
                        }).then((data) => {
                            this.$alert.success({content: '删除成功'});
                            this.$refs.lists.updateData({point_id: this.point_id});
                        }).catch((error) => {
                            this.$alert.error({content: '删除失败'});
                        });
                    }
                })
            },
            backEvent() {
                this.show = false;
                this.$emit('navigation','point');
            }
        }
    }
</script>

<style scoped>
    .whiteList {
        padding: 0 5px;
    }

    .whiteList > .header {
        height: 80px;
        padding: 0 15px;
    }

    .whiteList > .header > button {
        margin-top: 20px;
    }

    .filter>div{
        height: 36px;
        line-height: 36px;
        margin: 22px 0 0 20px;
    }
    .filter>div>input{
        width: 220px;
        border: 1px solid rgba(204, 204, 204, 1);
        border-radius: 3px;
        height: 34px;
        line-height: 34px;
    }
</style>